import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import appConfig from "../../../config/appConfig";
import { verifyPermission } from "../../../helpers/permission";
import { connect } from "react-redux";
import LoadingTable from "../LoadingTable";
import { verifyTokenExpire } from "../../../middleware/verifyToken";

const DashboardSocialMedia = (props) => {
  const [componentData, setComponentData] = useState("");
  const [channelData, setChannelData] = useState("");
  const [load, setLoad] = useState(true);
  const { dateEnd, dateStart, filterdate, spacialdate } = props;

  const defaultData = {
    series: [
      {
        name: "Enregistrées",
        data: channelData ? channelData.series.data : [],
      }     
    ],
    options: {
      chart: {
        height: 350,
        type: "bar",
        events: {
          click: function(chart, w, e) {},
        },
      },
      // colors: "#f3f3f8",
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: channelData ? channelData.options.xaxis.categories : [],
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
    },
  };

  useEffect(() => {
    let socialChannel = [];
    for (const channel in props.response.data.socialChannelsUse) {
      socialChannel.push(channel);
    }
    let newSocialChannel = { ...defaultData };
    newSocialChannel.options.xaxis.categories = socialChannel;
    if (
      verifyPermission(
        props.userPermissions,
        "show-dashboard-data-all-institution"
      )
    ) {
      
      if(props.response.data.socialChannelsUse){
        newSocialChannel.series[0].data = Object.values(
          props.response.data.socialChannelsUse
        ).map((serie) => serie.allInstitution);
      }
    } else if (
      verifyPermission(
        props.userPermissions,
        "show-dashboard-data-my-institution"
      )
    ) {
      if(props.response.data.socialChannelsUse){
        newSocialChannel.series[0].data = Object.values(
          props.response.data.socialChannelsUse
        ).map((serie) => serie.myInstitution);
      }
    }
    setChannelData(newSocialChannel);
    setComponentData(props.component);
    setLoad(false);
  }, [props.response]);
  return verifyPermission(
    props.userPermissions,
    "show-dashboard-data-all-institution"
  ) ||
    verifyPermission(
      props.userPermissions,
      "show-dashboard-data-my-institution"
    ) ? (
    <div className="kt-portlet">
      <div className="kt-portlet__head">
        <div className="kt-portlet__head-label">
          <h3 className="kt-portlet__head-title">
            Total des Réclamations reçues par Réseaux Sociaux
            {spacialdate !== ""
              ? ` sur les ${spacialdate?.match(/\d+/)[0]} derniers ${
                  spacialdate?.includes("months") ? " mois" : "jours"
                }`
              : filterdate !== ""
              ? ` au ${filterdate}`
              : dateStart !== ""
              ? ` du ${dateStart} au ${dateEnd}`
              : " sur les 30 derniers jours"}
          </h3>
        </div>
      </div>
      {load ? (
        <LoadingTable />
      ) : channelData ? (
        <div id="chart" className="kt-portlet__body">
          <Chart
            options={channelData.options}
            series={channelData.series}
            type="bar"
            height={350}
          />
          <div style={{ textAlign: "center", marginTop: "10px", fontWeight: "bold" }}>
            Total : {channelData.series[0].data.reduce((a, b) => a + b, 0)}
          </div>
        </div>
      ) : null}
    </div>
  ) : null;
};
const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
  };
};

export default connect(mapStateToProps)(DashboardSocialMedia);
